
import { deleteS3Object } from '@/aws/aws-s3';
import dynamoDB from '@/aws/aws-dynamoDB';

import awsconfig from '@/aws-exports';

export default async function (key, successCallback = e => e, errorCallback = e => e) {
  try {
    // delete file from storage
    const result = await deleteS3Object(key, awsconfig.aws_user_files_s3_bucket);
    // delete file from database
    await dynamoDB.deleteDBFile(key);

    // eslint-disable-next-line no-constant-condition
    if (result.$metadata.httpStatusCode >= 200 && result.$metadata.httpStatusCode < 300) {
      successCallback(key);
    } else {
      errorCallback(result);
    }
  } catch (e) {
    errorCallback(e);
  }
}
